import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { string } from "yup";
import { RootState, AppThunk } from "../../app/store";
import { fetchUserPermisionData } from "./rolebaseAPI";

export interface UserPermisionState {
  userPermisionData: any;
  isUserRole:string;
  status: "idle" | "loading" | "failed" | "success";
}

const initialState: UserPermisionState = {
  userPermisionData: "",
  isUserRole:"",
  status: "idle",
};

export const GetUserPermisionData = createAsyncThunk("UserPermision/fetchUserPermisionData", async () => {
  const response = await fetchUserPermisionData();
  return response;
});

export const UserPermisionSlice = createSlice({
  name: "UserPermision",
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(GetUserPermisionData.pending, (state) => {
        state.status = "loading";
      })
      .addCase(GetUserPermisionData.rejected, (state) => {
        state.status = "failed";
      })
      .addCase(GetUserPermisionData.fulfilled, (state, action) => {
        state.status = "success";
        state.userPermisionData = action.payload[0];
       // console.log(action.payload[0]?.roleName,"action.payload[0]?.roleName")
        state.isUserRole=action.payload?.roleName;
        if(action.payload[0]?.roleId===1){
           localStorage.setItem('isAdmin', JSON.stringify(true));
        }else{
          localStorage.setItem('isAdmin', JSON.stringify(false));
        }
        if(action.payload[0]?.groupPermissions===undefined){
          localStorage.setItem('store', JSON.stringify(false));
        }else{
          localStorage.setItem('store', JSON.stringify(true));
        }
        localStorage.setItem('URP', JSON.stringify(action.payload[0]?.groupPermissions));
      });
  },
});

export const {} = UserPermisionSlice.actions;

export const selectUserPermisionData = (state: RootState) => {
  return state.UserPermision.userPermisionData;
};

export default UserPermisionSlice.reducer;
